export default function getVolumeContent(stats, links) {
  let content = '';
  const newLine = '\r\n';

  /** header */
  const dates = stats.map(stat => `${stat.SeriesDate} (cc)`);
  content += 'ID,' + dates.join(',') + ',from latest (%),ROI Name' + newLine;

  /** rows */
  const sumValues = stats.map(stat => stat.sumOfLinks.volume);
  const sumChanges = stats.map(stat => stat.sumOfLinks.volumeChange);
  let latestChange = sumChanges[sumChanges.length - 1];
  content += 'Sum,' + sumValues.join(',') + `,${latestChange}%` + ',' + newLine;

  links.forEach(link => {
    const names = stats.map(stat => {
      const _link = stat.links.find(({ id }) => id === link.LinkID);
      return `${_link.names}`;
    });
    const latestName = names[names.length - 1];
    const nameCell = latestName.includes(',')
      ? JSON.stringify(latestName[latestName.length - 1]).replaceAll('"', "'")
      : latestName;
    const values = stats.map(stat => {
      const _link = stat.links.find(({ id }) => id === link.LinkID);
      return `${_link.volume}`;
    });
    const changes = stats.map(stat => {
      const _link = stat.links.find(({ id }) => id === link.LinkID);
      if (!_link.volumeChange) return '';
      return `${_link.volumeChange}%`;
    });
    content +=
      `${link.LinkID},` +
      values.join(',') +
      `,${changes[changes.length - 1]}` +
      `,${nameCell}` +
      newLine;
  });

  return content;
}
